import Vue from "vue/dist/vue.common.js";
import "./postcode-validator";

import VeeValidate from "vee-validate";

Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        invalid: "is-invalid"
    },
    events: "input|blur"
});